import { render, staticRenderFns } from "./GasbotRiveAnimation.vue?vue&type=template&id=3fbb8726&scoped=true"
import script from "./GasbotRiveAnimation.vue?vue&type=script&lang=ts"
export * from "./GasbotRiveAnimation.vue?vue&type=script&lang=ts"
import style0 from "./GasbotRiveAnimation.vue?vue&type=style&index=0&id=3fbb8726&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fbb8726",
  null
  
)

export default component.exports